const ScopeOfWork = ({ scopeOfWork }: { scopeOfWork: string }) => {
    return (
        <div>
            <div className="bg-green-primary text-center py-0.5 border-t border-black">
                <span className="text-[10px] font-bold text-white">
                    Section 2: Scope of Work
                </span>
            </div>
            <div className="border-y border-black p-1">
                <p className="text-[10px]">{scopeOfWork}</p>
            </div>
        </div>
    )
}

export default ScopeOfWork
